import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=14e19916&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=14e19916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../Monolith/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e19916",
  null
  
)

/* custom blocks */
import block0 from "./FAQ.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports